module.exports = require("@swa-ui/core/src/Background/Background.module.scss");